import { motion, useReducedMotion } from 'motion/react'
import type { ReactNode } from 'react'
import { motionTokens } from '../../../theme'

const joinClassNames = (...classNames: Array<string | null | undefined | false>) =>
  classNames.filter(Boolean).join(' ')

export const customerMotionEase = motionTokens.easingStandard
export const customerMotionTransition = {
  duration: motionTokens.durationNormalSeconds,
  ease: customerMotionEase,
}

type SkeletonBlockProps = {
  className?: string
}

export const SkeletonBlock = ({ className }: SkeletonBlockProps) => (
  <span
    aria-hidden
    className={joinClassNames(
      'block animate-pulse rounded-md bg-[color-mix(in_srgb,var(--color-border-default)_72%,transparent)] [animation-duration:1.25s]',
      className,
    )}
  />
)

type EmptyStateBlockProps = {
  icon?: ReactNode
  title: string
  description: string
  action?: ReactNode
  className?: string
}

export const EmptyStateBlock = ({ icon, title, description, action, className }: EmptyStateBlockProps) => {
  const reducedMotion = useReducedMotion()
  return (
    <motion.div
      initial={reducedMotion ? { opacity: 0 } : { opacity: 0, y: 6 }}
      animate={reducedMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
      transition={customerMotionTransition}
      className={joinClassNames(
        'ca-theme-transition rounded-lg border border-dashed border-(--color-border-default) bg-(--color-bg-surface-muted) px-4 py-6 text-center',
        className,
      )}
    >
      {icon ? (
        <span className="mx-auto inline-flex h-9 w-9 items-center justify-center rounded-full border border-(--color-border-default) bg-(--color-bg-card) text-(--color-text-muted)">
          {icon}
        </span>
      ) : null}
      <p className="mt-3 text-base font-semibold text-(--color-text-primary)">{title}</p>
      <p className="mt-1 text-sm text-(--color-text-secondary)">{description}</p>
      {action ? <div className="mt-4">{action}</div> : null}
    </motion.div>
  )
}
